import React from "react";
import {Helmet} from 'react-helmet';
import Faqs from "../Page/Faqs";
import Newsletter from "../Page/Newsletter";
import PopularHotels from "../Page/Hotels/Component/PopularHotels";
import PopularFlights from "../Page/PopularFlights";
import FlightsWidgit from "../Page/FlightsWidgit";
import Badge from "../Page/Badge";


function App1() {
  return (
   <>
    <Helmet>     
  <title>About Us, Lowest Airfare and offers | cheapflightsprices.com</title>
  <meta name="description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time"/>
  <meta name="keywords" content="Cheapflightsprices, Cheap Flights Prices,cheap flight booking, cheap flight fares,flight booking offer,Cheap Flights Prices,cheapest ticket booking"/>
<meta property="og:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta property="og:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta property="og:site_name" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta name="Distribution" content="Global" />
<meta name="Robots" content="follow, index, all" />
<meta name="googlebot" content="index, follow" />
<meta http-equiv="Expires" content="never" />
<meta name="document-type" content="public" />
<meta name="revisit-after" content="daily" />
<meta name="country" content="India" />
<meta name="Language" content="English" />
<meta name='rating' content="general" />
<meta name="author" content="cheapflightsprices.com" />
<link rel="canonical" href="https://cheapflightsprices.com/about-us.html" />
  </Helmet>
   <section id="banner_section" className="innerbannersection">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-2 pb-0">About Us</h1>
      <h2>Cheap Flights Prices Booking Start @ $24</h2>
      <FlightsWidgit/>
    </div>
  </section>
<Badge/>
 

    <main id="main">
    <section id="mainsection" className="section-with-bg">
      <div class="container" data-aos="fade-up">
  <div class="section-header">
    <h2>About <strong>Us</strong></h2>
  </div>
  <div class="designcontainer">

    <p>
      CheapFlightsPrices.com is an India-based travel platform providing online Domestic & International flight tickets. 
      Over the past few months, our platform has grown rapidly in terms of sales and user engagement. 
      What matters most to us is delivering real value to our users, helping them find the best fares and travel options easily.
    </p>

    <p>
      Unlike many other online booking systems, we display <strong>real-time flight availability</strong> instead of cached results. 
      This ensures you see actual available fares at the moment of search, avoiding frustration from outdated pricing or sold-out seats. 
      With CheapFlightsPrices.com, you can search and complete your flight booking in just a few minutes.
    </p>

    <h4>Private Fares & No Booking Fees</h4>
    <p>
      We offer the lowest fares by providing <strong>negotiated private fares</strong> and do not charge any additional booking fees. 
      All payments and bookings are processed securely by our trusted airline and travel partners.
    </p>

    <h4>User-Friendly Interface</h4>
    <p>
      Our platform offers a highly user-friendly interface with detailed flight options, multiple search tools, and filters to meet your specific travel needs. 
      We analyze hundreds of airlines, thousands of routes, and millions of itineraries to help you make the best choices efficiently.
    </p>

    <p>
      <strong>Affiliate & Booking Disclaimer:</strong> CheapFlightsPrices.com acts as a travel facilitator and comparison platform. 
      We do not sell tickets directly; all bookings are completed on our partner websites. This ensures secure payment processing and allows our users to take advantage of the best fares and offers.
    </p>

    <p>
      At CheapFlightsPrices.com, we handle the hard work behind the scenes so you can enjoy a smooth, reliable, and transparent travel booking experience.
    </p>

  </div>
</div>


    </section>
    <PopularFlights/>
        <PopularHotels />
    <Faqs/>
    <Newsletter/>
      </main>
    </>
  );
}
export default App1;
